import { z } from 'zod';

export const ownerSchema = z
  .object({
    first_name: z.string().min(1, { message: 'First name is required' }),
    last_name: z.string().min(1, { message: 'Last name is required' }),
    email: z.string().email({ message: 'Invalid email format' }),
    phone: z.string().min(10, { message: 'Invalid phone format' }),
    password: z.string().min(6, { message: 'Password must be at least 6 characters' }),
    confirm_password: z.string().min(1, { message: 'Please confirm your password' }),
  })
  .refine(data => data.password === data.confirm_password, {
    message: "Passwords don't match",
    path: ['confirm_password'],
  });

export type OwnerFormData = z.infer<typeof ownerSchema>;

export const technicianSchema = z
  .object({
    first_name: z.string().min(1, { message: 'First name is required' }),
    last_name: z.string().min(1, { message: 'Last name is required' }),
    email: z.string().email({ message: 'Invalid email format' }),
    phone_number: z.string().min(10, { message: 'Invalid phone format' }),
    password: z.string().min(6, { message: 'Password must be at least 6 characters' }),
    confirm_password: z.string().min(1, { message: 'Please confirm your password' }),
    send_email_notifications: z.boolean().optional(),
  })
  .refine(data => data.password === data.confirm_password, {
    message: "Passwords don't match",
    path: ['confirm_password'],
  });

export type TechnicianFormData = z.infer<typeof technicianSchema>;

export interface userOnClientCreationResponse {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

export const employeeSchema = z
  .object({
    first_name: z.string().min(1, { message: 'First name is required' }),
    last_name: z.string().min(1, { message: 'Last name is required' }),
    email: z.string().email({ message: 'Invalid email format' }),
    phone_number: z.string().min(10, { message: 'Invalid phone format' }),
    password: z.string().min(6, { message: 'Password must be at least 6 characters' }),
    confirm_password: z.string().min(1, { message: 'Please confirm your password' }),
    send_email_notifications: z.boolean().optional(),
  })
  .refine(data => data.password === data.confirm_password, {
    message: "Passwords don't match",
    path: ['confirm_password'],
  });
export type EmployeeFormData = z.infer<typeof employeeSchema>;
